import React from 'react'
import { useTranslation } from 'react-i18next'

import { TradingPoolCampaignLeaderboardTable } from '@pages/Traders-Room/Campaign-Results/Trading-Pools/TradingPoolCampaignLeaderboardTable'
import { useTradingPoolCampaignResults } from '@pages/Traders-Room/Campaign-Results/Trading-Pools/hooks/useTradingPoolCampaignResults'

import { Heading6 } from '@ui/Typography'
import { Divider } from '@ui/components/Divider'
import { LeaderBoardIcon } from '@ui/icons/LeaderBoard.icon'
import { Pagination } from '@ui/v2/Pagination/Pagination'

import { ScrollToIds } from '@hooks/useScrollToElementIds'

import { Box } from '@shared/components/Box'

export const TradingPoolCampaignLeaderboard: React.FC = () => {
  const { handlePageChange, tradingPoolCampResults, tradingAccountNames, maskAccountName } =
    useTradingPoolCampaignResults()
  const { t } = useTranslation()

  return (
    <Box flex direction={'column'} gap={'x8'}>
      <Box flex gap={'x8'} align={'center'}>
        <LeaderBoardIcon color={'text-high-em'} />
        <Heading6 medium>{t('RewardsHub.TradingPool.Leaderboard')}</Heading6>
      </Box>
      <Divider.Horizontal />
      <TradingPoolCampaignLeaderboardTable
        data={tradingPoolCampResults}
        isLoading={tradingPoolCampResults.isLoading}
        tradingAccountNames={tradingAccountNames}
        maskAccountName={maskAccountName}
      />
      <Pagination
        scrollToHeaderId={ScrollToIds.TradingPoolCampaignResultsHeader}
        maxPageSize={100}
        pageData={tradingPoolCampResults.meta}
        isLoading={tradingPoolCampResults.isLoading}
        onPageChanged={handlePageChange}
      />
    </Box>
  )
}
